import { render, staticRenderFns } from "./EditOther.vue?vue&type=template&id=4ff358d8&scoped=true&"
import script from "./EditOther.vue?vue&type=script&lang=js&"
export * from "./EditOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff358d8",
  null
  
)

export default component.exports